import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RequirementService } from 'src/app/services/requirement.service';
@Component({
    selector: 'app-delete-activity',
    templateUrl: './delete-activity.component.html',
    styleUrls: ['./delete-activity.component.scss'],
    standalone: false
})
export class DeleteActivityComponent implements OnInit {
	@Output() deleteFile = new EventEmitter<boolean>();
	@Input () idFile: number;
	@Input () title: string;
	@Input () message: number = -1;
	loading: boolean = false;
  constructor(
		public activeModal: NgbActiveModal,
		public _requirements: RequirementService,
	) { }

  ngOnInit() {
	}
	confirmDelete(event) {
		if (event) {
			this.loading = true;
			this._requirements.deleteActivity(this.idFile).subscribe((resp) => {
				if (resp['error']) {
					this.loading = false;
					this.message = 0;
				} else {
					this.message = 1;
					this.loading = false;
					setTimeout(() => this.activeModal.dismiss(), 1500);
					setTimeout(() => this.deleteFile.emit(true), 1500);
				}
			});
		}
	}
}
